// extracted by mini-css-extract-plugin
export default {"underline":"underline-7d7a"};